// extracted by mini-css-extract-plugin
export default {"slider":"slider__slider___1ZRMB"};